const FOM_SERVICE_URL = import.meta.env.VITE_FOM_SERVICE_URL

const fomService = {
  async getWebPlayInfo(playbookId) {
    const infoResponse = await fetch(`${FOM_SERVICE_URL}/getWebPlayInfo?playbookId=${playbookId}`)
    return await infoResponse.json()
  },

  async createPlay(playbookId, email, keywords, score, lastActiveSeparator, actionCard) {
    const playCreationUrl = new URL(`${FOM_SERVICE_URL}/createPlay`)
    playCreationUrl.searchParams.append('playbookId', playbookId)
    playCreationUrl.searchParams.append('email', email)
    playCreationUrl.searchParams.append('keywords', keywords)
    playCreationUrl.searchParams.append('score', score)
    playCreationUrl.searchParams.append('lastActiveSeparator', lastActiveSeparator || '')

    let playCreationResponse = await fetch(playCreationUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(actionCard),
    })
    if (playCreationResponse.status !== 200) {
      throw new Error('Failed to create play: ' + playCreationResponse.statusText)
    }
    return await playCreationResponse.text()
  },

  async createAnonymousToken() {
    const response = await fetch(`${FOM_SERVICE_URL}/createAnonymousToken`)
    return await response.text()
  },
}

export default fomService
